import { render, staticRenderFns } from "./AddCompanyClient.vue?vue&type=template&id=535463d5&"
import script from "./AddCompanyClient.vue?vue&type=script&lang=js&"
export * from "./AddCompanyClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports